"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReachTargetScoreForkRule = void 0;
const game_rule_1 = require("./game-rule");
class ReachTargetScoreForkRule extends game_rule_1.AbstractGameRule {
    constructor(playerId, thisRules, nextRules) {
        super();
        this.playerId = playerId;
        this.thisRules = thisRules;
        this.nextRules = nextRules;
    }
    applyRule(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const player = context.playerManager.playerFromId(this.playerId);
            if (player.hasReachedTargetScore && this.nextRules) {
                return yield this.nextRules.execute(commandHash, existingDeal, instant, context);
            }
            return yield this.thisRules.execute(commandHash, existingDeal, instant, context);
        });
    }
}
exports.ReachTargetScoreForkRule = ReachTargetScoreForkRule;
